import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { CBMError, Contract, User } from 'app/models';
import { ContractType, DataProviderType, IntendedUsageType } from 'app/models/enums';
import { ContractService } from 'app/services';

export interface PrefixWrapper {
  prefix: string;
}

@Component({
  selector: 'app-contract-detail',
  templateUrl: './admin-contract-detail.component.html',
  styleUrls: ['./admin-contract-detail.component.scss']
})
export class ContractDetailComponent implements OnInit {
  PREFIX_SEPARATOR = ';';

  contractNotFound = false;

  errorMessages: CBMError[] = [];

  id: number;
  contract: Contract = new Contract(null, null, null, false, null, null);
  newContract = true;
  contractTypes: ContractType[] = [ContractType.DataProvider, ContractType.FCD];
  intendedUsageTypes: IntendedUsageType[] = [IntendedUsageType.REALTIME, IntendedUsageType.ANALYTICS];
  dataProviderTypes: DataProviderType[] = [DataProviderType.MST, DataProviderType.Intekenen];
  contractHasUsers = false;
  contractUsers: User[] = [];

  prefixes: string[] = [null];

  public isSaving = false;

  constructor(
    private readonly contractService: ContractService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
    if (this.id != null) {
      this.newContract = false;
      this.contract.id = this.id;

      this.contractService.getContract(this.id).subscribe(
        contract => {
          this.contract = contract;
          this.prefixes = this.contractPrefixToArray();
          this.linkUsers();
          this.enforceNonDataproviderValuesNull();
        },
        error => {
          console.error('error occurred: ', error);
          if (error.startsWith('404')) {
            // ContractNotFound
            this.contractNotFound = true;
          }
        }
      );
    }
  }

  linkUsers() {
    if (this.contract.users.length > 0) {
      this.contractHasUsers = true;
      for (const user of this.contract.users) {
        if (user.active) {
          this.contractUsers.push(user);
        }
      }
    }
  }

  onPrefixChange(): void {
    // merge multiple prefixes back into the contract prefix field
    this.contract.prefix = this.arrayToContractPrefix();
  }

  prefixIsDuplicate(ownIndex: number): boolean {
    return this.prefixes.some((p, i, arr) => {
      const dupe: boolean = arr.indexOf(p) !== i;
      return dupe && i === ownIndex;
    });
  }
  haveDuplicatePrefixes(): boolean {
    return this.prefixes.some((p, i, arr) => arr.indexOf(p) !== i);
  }

  enforceNonDataproviderValuesNull(): void {
    if (this.contract.contractType !== ContractType.DataProvider) {
      this.contract.dataproviderType = null;
      this.contract.mstId = null;
      this.contract.mstVersionNr = null;
      this.contract.nationalIdentifier = null;
    }
  }

  contractPrefixToArray(): string[] {
    if (this.contract && this.contract.prefix) {
      return this.contract.prefix.trim().split(this.PREFIX_SEPARATOR);
    } else {
      return [null]; // one empty prefix so the first input shows up
    }
  }
  arrayToContractPrefix(): string {
    if (this.prefixes) {
      return this.prefixes
        .filter(p => p != null)
        .map(p => p.trim())
        .filter(p => p !== '')
        .join(this.PREFIX_SEPARATOR);
    } else {
      return null;
    }
  }

  addPrefix(): void {
    this.prefixes.push(null);
    this.onPrefixChange();
  }
  removePrefix(i: number): void {
    this.prefixes.splice(i, 1);
    this.onPrefixChange();
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  onSubmit() {
    this.errorMessages = [];
    this.isSaving = true;

    let updatedOrCreatedContract: Observable<Contract>;

    if (this.newContract === true) {
      updatedOrCreatedContract = this.contractService.createContract(this.contract);
    } else {
      updatedOrCreatedContract = this.contractService.updateContract(this.contract);
    }

    updatedOrCreatedContract.subscribe(
      savedContract => {
        console.log('contract updated/created: ', savedContract);
        this.router.navigate(['/admin/contracts']);
        this.isSaving = false;
      },
      (errors: CBMError[]) => {
        console.log(errors);
        this.errorMessages = errors;
        this.isSaving = false;
      }
    );
  }

  backToContractOverview(): void {
    this.router.navigate(['admin/contracts']);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/contracts/admin-contract-detail.component.ts